export const detailDialogButtons = (handleClose, handleOpenUnlockIccDialog) => [
  {
    label: 'Aceptar',
    variant: 'contained',
    onClick: handleClose,
    buttonColor: 'purple',
    textColor: 'white',
  },
  {
    label: 'Desbloquear ICC',
    variant: 'contained',
    onClick: handleOpenUnlockIccDialog,
    buttonColor: 'secondary',
    textColor: 'white',
  },
];

export const successDialogButtons = (handleCloseSuccessDialog) => [
  {
    label: 'Aceptar',
    variant: 'contained',
    onClick: handleCloseSuccessDialog,
    buttonColor: 'purple',
    textColor: 'white',
  },
];

export const errorDialogButtons = (handleClose) => [
  {
    label: 'Aceptar',
    variant: 'contained',
    onClick: handleClose,
    buttonColor: 'purple',
    textColor: 'white',
  },
];
